import { FormattedMessage } from 'react-intl';
import type { Message, UserMessage as UserMessageType } from 'src/types';

interface UserMessageProps {
	message: UserMessageType;
	handleEdit: {
		enable: (message: Message) => void;
		disable: () => void;
	};
	editing: Message | null;
}

const UserMessage = ({ message, handleEdit, editing }: UserMessageProps) => {
	const { text, file } = message;
	const { disable, enable } = handleEdit;
	const sameMessageEdited = editing && editing.id === message.id;
	const handleEditMessage = (): void => (sameMessageEdited ? disable() : enable(message));

	return (
		<article className="chat-message user-message">
			<div className="message-wrapper">
				<span className="text">{text}</span>
			</div>
			{file && (
				<div className="user-message-image">
					<img alt="message" height={180} style={{ marginTop: 20 }} src={file} />
				</div>
			)}
			<div className={`buttons${sameMessageEdited ? ' edit' : ''}`} onClick={handleEditMessage} role="button">
				{sameMessageEdited ? (
					<span>
						<FormattedMessage id="user-message.edit.cancel" />
					</span>
				) : (
					<span className="icon icon-write" />
				)}
			</div>
		</article>
	);
};

export default UserMessage;
